import { useLocation } from 'react-router-dom';
import { IMenuItem } from 'types/menu.js';
import { NavMenuItem } from './nav-menu-item.js';

export type NavMenuActiveCB = ({ currentUrl, linkUrl }: { currentUrl: string; linkUrl: string }) => boolean;

export const NavMenuItemList = ({
  menu,
  onClick,
  className,
  activeCB,
}: {
  menu: Array<IMenuItem>;
  activeCB: NavMenuActiveCB;
  onClick?: () => void;
  className: string;
}) => {
  const path = useLocation().pathname;
  const result = menu.map((item, index) => (
    <NavMenuItem
      key={index}
      item={item}
      className={className}
      active={activeCB({ currentUrl: path, linkUrl: item.link })}
      onClick={onClick}
    />
  ));
  return result;
};
